import React, { ReactNode } from 'react';
import { Root } from '../entities/Root';

export class RootVisual extends React.Component<{ object: Root, children?: ReactNode }> {

    public render() {
        return this.props.children ?? null;
    }
}
